module.exports = __webpack_public_path__ + "img/KK.aca24a4a.png";